import { useAppSelector } from 'app/hooks/redux';

export const useNotifications = () => {
  const notificationState = useAppSelector(state => state.notification);
  
  return {
    unreadCount: notificationState.unreadCount,
    headerNotifications: notificationState.headerNotifications,
    headerTotalCount: notificationState.headerTotalCount,
    isLoading: notificationState.isLoading
  };
}; 